import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import SubmitButton from 'components/styled-component/ReusableButton';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  InputLabel,
  Grid,
  Divider,
  Input,
  IconButton,
  CircularProgress,
  Autocomplete,
  Backdrop,
} from "@mui/material";
import inputLabel from "assets/theme/components/form/inputLabel";
import LocationPicker from "./locationPicker";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import avatar from "assets/theme/components/avatar";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddStoreForm = ({ onClose, onSuccess, initialData }) => {
  console.log("🚀 ~ AddStoreForm ~ store:", initialData);
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [userId, setUserId] = useState(null);
  const [userData, setuserData] = useState({
    name: initialData?.owner?.name || "",
    email: initialData?.owner?.email || "",
    password: "",
    password_confirmation: "",
    phone: initialData?.owner?.phone || "",
    type: initialData?.owner?.type || "manager",
    avatar: initialData?.owner?.avatar || null,
    id: initialData?.owner?.id || null, // Add ID field
  });
  const [formData, setFormData] = useState({
    name_ar: initialData?.name_ar || "",
    name_en: initialData?.name_en || "",
    mailbox: initialData?.mailbox || "",
    email: initialData?.email || "",
    phone: initialData?.phone || "",
    street: initialData?.street || "",
    zip_code: initialData?.zip_code || "",
    subcode: initialData?.subcode || "",
    logo: null,
    id: initialData?.id || null, // Add ID field
    user_id: initialData?.user_id || null,
    status: initialData?.status || 0, // Add ID field
    lat: initialData?.lat || "",
    lng: initialData?.lng || "",
    address: initialData?.address || "",
    location: initialData?.location || "",
    location_id: initialData?.location_id || "",
    business_activity_id: initialData?.business_activity_id || "",
    market_id: initialData?.market_id || "",
  });
  const [showMap, setShowMap] = useState(false);
  const [isValidMapUrl, setIsValidMapUrl] = useState(false);
  const [mapUrl, setMapUrl] = useState("");
  const [showError, setShowError] = useState(false);
  const [iframeError, setIframeError] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");

  // --- state للقوائم والقيم المختارة ---
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(
    initialData?.location_hierarchy?.region?.id || null
  );
  console.log("🚀 ~ AddStoreForm ~ selectedRegion:", selectedRegion);
  console.log("🚀 ~ AddStoreForm ~ selected:", initialData?.location_hierarchy?.region?.id);
  const [selectedCity, setSelectedCity] = useState(
    initialData?.location_hierarchy?.province?.id || null
  );
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [businessActivities, setBusinessActivities] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [selectedBusinessActivity, setSelectedBusinessActivity] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);

  const [geoErrors, setGeoErrors] = useState({ country: "", region: "", city: "" });

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [storeImages, setStoreImages] = useState([]);
  const [imagesError, setImagesError] = useState("");

  // Regex to validate Google Maps URL
  const isValidGoogleMapsURL = (url) => {
    const googleMapsRegex =
      /((maps\.google\.com)|(google\.com\/maps)|(maps\.app\.goo\.gl)|(goo\.gl\/maps))/i;
    return googleMapsRegex.test(url);
  };

  // استخراج الإحداثيات من الرابط
  function extractLatLng(url) {
    // أمثلة: .../maps?q=24.7136,46.6753 أو .../@24.7136,46.6753,17z
    const qMatch = url.match(/[?&]q=([\d.\-]+),([\d.\-]+)/);
    if (qMatch) return { lat: qMatch[1], lng: qMatch[2] };
    const atMatch = url.match(/@([\d.\-]+),([\d.\-]+),/);
    if (atMatch) return { lat: atMatch[1], lng: atMatch[2] };
    return null;
  }

  // دالة استخراج src من كود iframe
  function extractIframeSrc(iframeCode) {
    const match = iframeCode.match(/<iframe[^>]*src=["']([^"']+)["']/);
    return match ? match[1] : null;
  }
  // دالة استخراج الإحداثيات من src
  function extractLatLngFromSrc(src) {
    // أمثلة: .../maps?q=24.7136,46.6753&... أو ...!3d24.7136!4d46.6753
    const qMatch = src.match(/[?&]q=([\d.\-]+),([\d.\-]+)/);
    if (qMatch) return { lat: qMatch[1], lng: qMatch[2] };
    // دعم نمط !3d...!4d... حتى لو كان هناك أرقام عشرية طويلة
    const dMatch = src.match(/!3d([\d.\-]+)!4d([\d.\-]+)/);
    if (dMatch) return { lat: dMatch[1], lng: dMatch[2] };
    // دعم نمط !2d...!3d... (أحياناً يسبق !3d الإحداثيات !2d للخط)
    const d2Match = src.match(/!2d([\d.\-]+)!3d([\d.\-]+)/);
    if (d2Match) return { lat: d2Match[2], lng: d2Match[1] };
    return null;
  }

  const handleLocationChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "location") {
      if (!value.trim()) {
        setErrors((prev) => ({ ...prev, location: "هذا الحقل مطلوب" }));
        setMapUrl(null);
        setShowError(false);
      } else if (!isValidGoogleMapsURL(value)) {
        setErrors((prev) => ({ ...prev, location: "يرجى إدخال رابط صحيح لخرائط جوجل" }));
        setMapUrl(null);
        setShowError(true);
      } else {
        setErrors((prev) => ({ ...prev, location: "" }));
        setMapUrl(value);
        setShowError(false);
      }
    }
  };

  // عند الخروج من حقل الموقع
  const handleLocationBlur = (e) => {
    const value = e.target.value.trim();
    if (!value) {
      setIsValidMapUrl(false);
      setShowMap(false);
      setMapUrl("");
      setErrors((prev) => ({ ...prev, location: "هذا الحقل مطلوب" }));
      return;
    }
    // إذا كان رابط embed مباشر
    if (/\/maps\/embed/.test(value)) {
      setIsValidMapUrl(true);
      setShowMap(true);
      setMapUrl(value);
      setErrors((prev) => ({ ...prev, location: "" }));
      return;
    }
    // إذا كان يحتوي على إحداثيات
    const coords = extractLatLng(value);
    if (coords) {
      const embedUrl = `https://maps.google.com/maps?q=${coords.lat},${coords.lng}&output=embed`;
      setIsValidMapUrl(true);
      setShowMap(true);
      setMapUrl(embedUrl);
      setErrors((prev) => ({ ...prev, location: "" }));
      return;
    }
    // إذا كان رابط مشاركة مختصر أو غير مدعوم
    setIsValidMapUrl(false);
    setShowMap(false);
    setMapUrl("");
    setErrors((prev) => ({
      ...prev,
      location:
        "يرجى إدخال رابط مباشر من خرائط جوجل يحتوي على الإحداثيات (lat,lng) أو رابط التضمين (embed) من خيار مشاركة الخريطة.",
    }));
  };

  // عند الخروج من حقل iframe
  const handleIframeBlur = (e) => {
    const value = e.target.value.trim();
    setFormData((prev) => ({ ...prev, location: value }));
    if (!value) {
      setIframeError("يرجى إدخال كود التضمين (iframe) من خرائط جوجل");
      setIframeSrc("");
      setFormData((prev) => ({ ...prev, lat: "", lng: "", location: "" }));
      return;
    }
    const src = extractIframeSrc(value);
    if (!src) {
      setIframeError("الكود المدخل غير صحيح. يرجى لصق كود iframe كامل من خرائط جوجل.");
      setIframeSrc("");
      setFormData((prev) => ({ ...prev, lat: "", lng: "", location: "" }));
      return;
    }
    console.log("[onBlur] Extracted src:", src);
    setIframeError("");
    setIframeSrc(src);
    // استخراج الإحداثيات إذا أمكن
    const coords = extractLatLngFromSrc(src);
    if (coords) {
      setFormData((prev) => ({ ...prev, lat: coords.lat, lng: coords.lng }));
      console.log("[onBlur] Extracted coordinates:", coords.lat, coords.lng);
    } else {
      setFormData((prev) => ({ ...prev, lat: "", lng: "" }));
    }
    console.log("coords: ", coords);
  };

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setuserData({
        name: initialData.owner?.name || "",
        email: initialData.owner?.email || "",
        phone: initialData.owner?.phone || "",
        type: "manager",
        avatar: initialData.owner?.avatar || null, // Keep as string for existing images
        id: initialData.owner?.id || null,
        password: "",
        password_confirmation: "",
      });
      setFormData({
        name_ar: initialData?.name_ar,
        name_en: initialData?.name_en,
        mailbox: initialData?.mailbox,
        email: initialData?.email,
        phone: initialData?.phone,
        location: initialData?.location,
        street: initialData?.street,
        zip_code: initialData?.zip_code,
        subcode: initialData?.subcode,
        logo: initialData.logo,
        id: initialData?.id, // Add ID field
        user_id: initialData?.user_id,
        status: initialData.status,
        lat: initialData?.lat || "",
        lng: initialData?.lng || "",
        address: initialData?.address || "",
        location: initialData?.location || "",
        location_id: initialData?.location_id || "",
        business_activity_id: initialData?.business_activity_id || "",
        market_id: initialData?.market_id || "",
      });
      setUserId(initialData?.owner?.id || null);
      // Check if location is valid initially
      if (initialData?.location && isValidGoogleMapsURL(initialData.location)) {
        setMapUrl(initialData.location);
      }
      // --- الإضافة الجديدة: استخراج IFRAME تلقائياً ---
      if (initialData?.location) {
        const src = extractIframeSrc(initialData.location);
        if (src) {
          setIframeSrc(src);
          setIframeError("");
          // استخراج الإحداثيات إذا أمكن
          const coords = extractLatLngFromSrc(src);
          if (coords) {
            setFormData((prev) => ({ ...prev, lat: coords.lat, lng: coords.lng }));
            console.log("[initialData] Extracted coordinates:", coords.lat, coords.lng);
          }
        } else {
          setIframeSrc("");
          setIframeError("الكود المدخل غير صحيح. يرجى لصق كود iframe كامل من خرائط جوجل.");
          setFormData((prev) => ({ ...prev, lat: "", lng: "" }));
        }
      }
    }
  }, [initialData]);

  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [userErrors, setUserErrors] = useState({});
  const [userFormSubmitted, setUserFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);
  useEffect(() => {
    if (userFormSubmitted) validateUserForm();
  }, [userData]);

  const validateForm = () => {
    if (!userId) {
      Swal.fire({
        icon: "error",
        title: "فشل الحفظ",
        text: "يجب ادخال بيانات المستخدم الاساسية اولا",
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      return;
    }
    const newErrors = {};
    // تحقق من الحقول الجغرافية
    if (!selectedCountry) newErrors.country = "يجب اختيار الدولة";
    if (!selectedRegion) newErrors.region = "يجب اختيار المنطقة/المحافظة";
    if (!selectedCity) newErrors.city = "يجب اختيار المدينة/الحي";
    // تحقق من النشاط التجاري والسوق
    if (!selectedBusinessActivity) newErrors.businessActivity = "يجب اختيار النشاط التجاري";
    if (!selectedMarket) newErrors.market = "يجب اختيار السوق";
    // إذا كان هناك خطأ في الحقول الجغرافية اعتبر النموذج غير صالح
    if (!validateRequired(formData.name_ar)) newErrors.name_ar = "يجب إدخال الاسم";
    if (!validateRequired(formData.name_en)) newErrors.name_en = "يجب إدخال الاسم";
    if (!validateEmail(formData.email)) newErrors.email = "بريد إلكتروني غير صالح";
    if (!validateRequired(formData.phone)) newErrors.phone = "يجب إدخال الهاتف";
    if (!validateRequired(formData.location))
      newErrors.location = "يجب إدخال رابط موقع من خرائط جوجل";
    if (!validateRequired(formData.street)) newErrors.street = "يجب إدخال العنوان";
    if (!validateRequired(formData.zip_code)) newErrors.zip_code = "يجب إدخال الرمز البريدي";
    if (!formData.logo) newErrors.logo = "يجب اختيار صورة المتجر";
    if (storeImages.length === 0) setImagesError("يجب اختيار صورة واحدة على الأقل للمتجر");
    else setImagesError("");
    if (storeImages.length === 0) return false;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateUserForm = () => {
    const newErrors = {};
    if (!validateRequired(userData.name)) newErrors.name = "يجب إدخال الاسم";
    if (!validateEmail(userData.email)) newErrors.email = "بريد إلكتروني غير صالح";
    if (!userData.id) {
      if (!validateRequired(userData.password)) newErrors.password = "يجب إدخال كلمة السر";
      if (!validatePasswordMatch(userData.password, userData.password_confirmation))
        newErrors.confirmPassword = "كلمة السر غير متطابقة";
    }
    if (!validateRequired(userData.type)) newErrors.userType = "يجب اختيار النوع";
    setUserErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setuserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUserImageChange = (e) => {
    const file = e.target.files[0];
    if (file && ["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
      setuserData((prev) => ({ ...prev, avatar: file }));
      setUserErrors((prev) => ({ ...prev, avatar: "" }));
    } else {
      setUserErrors((prev) => ({ ...prev, avatar: "يجب أن تكون الصورة بصيغة PNG, JPG, أو GIF" }));
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setFormData((prev) => ({ ...prev, logo: null }));
      setErrors((prev) => ({
        ...prev,
        logo: "يجب اختيار شعار المتجر",
      }));
      return;
    }
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
    if (!allowedTypes.includes(file.type)) {
      setFormData((prev) => ({ ...prev, logo: null }));
      setErrors((prev) => ({
        ...prev,
        logo: "يجب أن تكون الصورة بصيغة jpeg PNG أو JPG أو GIF فقط",
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, logo: file }));
    setErrors((prev) => ({ ...prev, logo: "" }));
  };

  const handleStoreImagesChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) {
      setStoreImages([]);
      setImagesError("يجب اختيار صورة واحدة على الأقل للمتجر");
      return;
    }
    setStoreImages(files);
    setImagesError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!validateForm()) return;

    formData.user_id = userId;
    formData.location_id = selectedCity ? selectedCity.id : "";
    console.log("بيانات المتجر المرسلة:", formData);
    try {
      const formPayload = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          if (key === "logo") {
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });

      storeImages.forEach((img, idx) => {
        formPayload.append("image", img);
      });

      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });

      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/stores/update/ ${formData.id}`
        : BASE_URL + "/administrator/stores/store ";
      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.close();
      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";
      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();
    setUserFormSubmitted(true);
    if (!validateUserForm()) return;
    try {
      const formPayload = new FormData();
      Object.entries(userData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          if (key === "avatar") {
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });

      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });

      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/users/update/ ${userData.id}`
        : BASE_URL + "/administrator/users/store ";
      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("USERID: ", response.data.data.id);
      setUserId(response.data.data.id);

      Swal.close();
      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";
      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setUserFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name_ar: "",
      name_en: "",
      mailbox: "",
      phone: "",
      location: "",
      street: "",
      zip_code: "",
      subcode: "",
      logo: null,
      merchant_id: null,
    });
    setErrors({});
    onClose();
  };

  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, logo: null }));
  };

  // --- جلب الدول عند التحميل ---
  useEffect(() => {
    setLoadingCountries(true);
    axios
      .get(BASE_URL + "/administrator/locations/countries", {
        headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` },
      })
      .then((res) => setCountries(res.data.data || []))
      .catch(() => setCountries([]))
      .finally(() => setLoadingCountries(false));
  }, []);

  // --- جلب المناطق عند تغيير الدولة ---
  useEffect(() => {
    if (!selectedCountry) {
      setRegions([]);
      setSelectedRegion(null);
      setCities([]);
      setSelectedCity(null);
      return;
    }
    setLoadingRegions(true);
    setRegions([]);
    setSelectedRegion(initialData?.location_hierarchy?.region?.id || null);
    setCities([]);
    setSelectedCity(initialData?.location_hierarchy?.province?.id || null);
    axios
      .get(
        `${BASE_URL}/administrator/locations/children/${selectedCountry.id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` } }
      )
      .then((res) => setRegions(res.data.data || []))
      .catch(() => setRegions([]))
      .finally(() => setLoadingRegions(false));
  }, [selectedCountry]);

  // --- جلب المدن عند تغيير المنطقة ---
  useEffect(() => {
    if (!selectedRegion) {
      setCities([]);
      setSelectedCity(null);
      return;
    }
    setLoadingCities(true);
    setCities([]);
    setSelectedCity(null);
    axios
      .get(
        `${BASE_URL}/administrator/locations/children/${selectedRegion.id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` } }
      )
      .then((res) => setCities(res.data.data || []))
      .catch(() => setCities([]))
      .finally(() => setLoadingCities(false));
  }, [selectedRegion]);

  // --- عند التعديل: تعيين الدولة/المنطقة/المدينة من بيانات المتجر بعد تحميل الخيارات ---
  useEffect(() => {
    if (!initialData || !initialData.location_hierarchy || countries.length === 0) return;
    const { country } = initialData.location_hierarchy;
    if (country) {
      const found = countries.find((c) => c.id === country.id);
      if (found) setSelectedCountry(found);
    }
  }, [countries, initialData]);
  useEffect(() => {
    if (!initialData || !initialData.location_hierarchy || regions.length === 0) return;
    const { region } = initialData.location_hierarchy;
    if (region) {
      const found = regions.find((r) => r.id === region.id);
      if (found) setSelectedRegion(found);
    }
  }, [regions, initialData]);
  useEffect(() => {
    if (!initialData || !initialData.location_hierarchy || cities.length === 0) return;
    const { province } = initialData.location_hierarchy;
    if (province) {
      const found = cities.find((c) => c.id === province.id);
      if (found) setSelectedCity(found);
    }
  }, [cities, initialData]);

  // جلب الأنشطة التجارية
  useEffect(() => {
    axios
      .get(BASE_URL + "/administrator/business-activities", {
        headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` },
      })
      .then((res) => setBusinessActivities(res.data.data || []))
      .catch(() => setBusinessActivities([]));
  }, []);

  // جلب الأسواق
  useEffect(() => {
    axios
      .get(BASE_URL + "/administrator/markets", {
        headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` },
      })
      .then((res) => setMarkets(res.data.data || []))
      .catch(() => setMarkets([]));
  }, []);

  // جلب المستخدمين عند التحميل
  useEffect(() => {
    setLoadingUsers(true);
    axios
      .get(BASE_URL + "/administrator/users", {
        headers: { Authorization: `Bearer ${localStorage.getItem("user-token")}` },
      })
      .then((res) => setUsers(res.data.data || []))
      .catch(() => setUsers([]))
      .finally(() => setLoadingUsers(false));
  }, []);

  // --- عند التعديل: تعيين النشاط التجاري والسوق من بيانات المتجر بعد تحميل الخيارات ---
  useEffect(() => {
    if (!initialData || businessActivities.length === 0) return;
    // استخدم business_activitie_id أو business_activity_id
    const activityId = initialData.business_activitie_id || initialData.business_activity_id;
    if (activityId) {
      const found = businessActivities.find((b) => b.id === activityId);
      if (found) setSelectedBusinessActivity(found);
    }
  }, [businessActivities, initialData]);
  useEffect(() => {
    if (!initialData || markets.length === 0) return;
    if (initialData.market_id) {
      const found = markets.find((m) => m.id === initialData.market_id);
      if (found) setSelectedMarket(found);
    }
  }, [markets, initialData]);

  return (
    <>
      <Backdrop
        open={loadingCountries || loadingRegions || loadingCities || loadingUsers}
        sx={{ zIndex: 2000, color: "#fff", backgroundColor: "rgba(255,255,255,0.5)" }}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        sx={{
          p: 3,
          width: "100%",
          bgcolor: darkMode ? theme.palette.background.default : "background.paper",
          borderRadius: 2,
          boxShadow: 3,
          color: darkMode ? "white !important" : "inherit",
        }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h5" fontWeight="bold">
            {formData.id ? "تعديل بيانات المتجر" : "إضافة متجر جديد"}
          </Typography>
        </Box>
        {/* إذا تم اختيار مستخدم، أخفِ أو عطّل قسم إنشاء مستخدم جديد */}
        {!selectedUser && (
          <>
            {/* Main User Info */}
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              معلومات المستخدم الاساسية
            </Typography>
            <Grid container spacing={3}>
              <Grid item size={6}>
                <FormControl fullWidth error={!!userErrors.name} sx={{ mb: 2 }}>
                  <TextField
                    label="الاسم الكامل *"
                    name="name"
                    value={userData.name}
                    onChange={handleUserChange}
                    error={!!userErrors.name}
                    helperText={userErrors.name}
                  />
                </FormControl>
                <FormControl fullWidth error={!!userErrors.email} sx={{ mb: 2 }}>
                  <TextField
                    label="البريد الإلكتروني *"
                    name="email"
                    type="email"
                    value={userData.email}
                    onChange={handleUserChange}
                    error={!!userErrors.email}
                    helperText={userErrors.email}
                  />
                </FormControl>
                <FormControl fullWidth error={!!userErrors.phone} sx={{ mb: 2 }}>
                  <TextField
                    label="رقم الهاتف *"
                    name="phone"
                    value={userData.phone}
                    onChange={handleUserChange}
                    error={!!userErrors.phone}
                    helperText={userErrors.phone}
                  />
                </FormControl>
              </Grid>
              <Grid item size={6}>
                <FormControl fullWidth error={!!userErrors.password} sx={{ mb: 2 }}>
                  <TextField
                    label="كلمة المرور *"
                    name="password"
                    type="password"
                    value={userData.password}
                    onChange={handleUserChange}
                    error={!!userErrors.password}
                    helperText={userErrors.password}
                  />
                </FormControl>
                <FormControl fullWidth error={!!userErrors.confirmPassword} sx={{ mb: 2 }}>
                  <TextField
                    label="تأكيد كلمة المرور *"
                    name="password_confirmation"
                    type="password"
                    value={userData.password_confirmation}
                    onChange={handleUserChange}
                    error={!!userErrors.confirmPassword}
                    helperText={userErrors.confirmPassword}
                  />
                </FormControl>
              </Grid>
            </Grid>

            {/* Image Upload Section */}
            <Box mt={3}>
              <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                صورة المستخدم
              </Typography>
              <Input
                type="file"
                inputProps={{ accept: "image/png, image/jpeg, image/gif" }}
                onChange={handleUserImageChange}
                sx={{ display: "none" }}
                id="image-upload"
                name="avatar"
              />
              <label htmlFor="image-upload">
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<AddIcon />}
                  sx={{ width: 200, borderColor: "secondary.focus", color: "primary.main" }}
                >
                  تحميل الصورة
                </Button>
              </label>
              {userData.avatar && (
                <Avatar
                  src={
                    typeof userData.avatar === "string"
                      ? `https://back.al-balad.sa/uploads/users/avatars/${userData.avatar}`
                      : URL.createObjectURL(userData.avatar)
                  }
                  sx={{
                    width: 100,
                    height: 100,
                    mt: 2,
                    border: "2px solid #ddd",
                  }}
                />
              )}
              <Typography variant="caption" color="textSecondary" display="block" mt={1}>
                (PNG, JPG, GIF فقط)
              </Typography>
              <FormHelperText error>{userErrors.avatar}</FormHelperText>
            </Box>

            {/* Actions Section */}
            <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" color="textSecondary">
                * الحقول المطلوبة
              </Typography>
              <Box display="flex" gap={2}>
                <SubmitButton

                  variant="primary"

                  onClick={handleUserSubmit}
                  sx={{ px: 4, color: "white !important" }}
                >
                  حفظ
                </SubmitButton>
              </Box>
            </Box>
          </>
        )}

        {/* Store Info */}
        <Box mt={4}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            معلومات المتجر
          </Typography>
          <Box display="flex" gap={2} alignItems="center" mb={3}>
            <Autocomplete
              options={countries}
              getOptionLabel={(option) => option.name || ""}
              loading={loadingCountries}
              value={selectedCountry}
              onChange={(_, value) => setSelectedCountry(value)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="الدولة"
                  required
                  sx={{ minWidth: 300 }}
                  error={!!errors.country}
                  helperText={errors.country}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingCountries ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <Autocomplete
              options={regions}
              getOptionLabel={(option) => option.name || ""}
              loading={loadingRegions}
              value={selectedRegion}
              onChange={(_, value) => setSelectedRegion(value)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disabled={!selectedCountry}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="المنطقة / المحافظة"
                  required
                  sx={{ minWidth: 300 }}
                  error={!!errors.region}
                  helperText={errors.region}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingRegions ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <Autocomplete
              options={cities}
              getOptionLabel={(option) => option.name || ""}
              loading={loadingCities}
              value={selectedCity}
              onChange={(_, value) => setSelectedCity(value)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disabled={!selectedRegion}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="المدينة / الحي"
                  required
                  sx={{ minWidth: 300 }}
                  error={!!errors.city}
                  helperText={errors.city}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingCities ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
            <FormControl fullWidth error={!!errors.name_ar} sx={{ mb: 2 }}>
              <TextField
                label="الاسم بالعربي*"
                name="name_ar"
                value={formData.name_ar}
                onChange={handleChange}
                error={!!errors.name_ar}
                helperText={errors.name_ar}
              />
            </FormControl>
            <FormControl fullWidth error={!!errors.name_en} sx={{ mb: 2 }}>
              <TextField
                label="الاسم بالانجليزي*"
                name="name_en"
                value={formData.name_en}
                onChange={handleChange}
                error={!!errors.name_en}
                helperText={errors.name_en}
              />
            </FormControl>
          </Box>
          {/* صف الهاتف والبريد الإلكتروني */}
          <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
            <FormControl fullWidth error={!!errors.phone} sx={{ mb: 2 }}>
              <TextField
                label="الهاتف *"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={!!errors.phone}
                helperText={errors.phone}
              />
            </FormControl>
            <FormControl fullWidth error={!!errors.email} sx={{ mb: 2 }}>
              <TextField
                label="البريد الإلكتروني *"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
              />
            </FormControl>
            {/* حقل النشاط التجاري Autocomplete */}
            <FormControl fullWidth error={!!errors.businessActivity} sx={{ mb: 2, minWidth: 220 }}>
              <Autocomplete
                options={businessActivities}
                getOptionLabel={(option) => option.name || ""}
                value={selectedBusinessActivity}
                onChange={(_, value) => {
                  setSelectedBusinessActivity(value);
                  setFormData((prev) => ({
                    ...prev,
                    business_activitie_id: value ? value.id : "",
                  }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="النشاط التجاري *"
                    required
                    error={!!errors.businessActivity}
                    helperText={errors.businessActivity}
                  />
                )}
              />
            </FormControl>
            {/* حقل السوق Autocomplete */}
            <FormControl fullWidth error={!!errors.market} sx={{ mb: 2, minWidth: 220 }}>
              <Autocomplete
                options={markets}
                getOptionLabel={(option) => option.name || ""}
                value={selectedMarket}
                onChange={(_, value) => {
                  setSelectedMarket(value);
                  setFormData((prev) => ({ ...prev, market_id: value ? value.id : "" }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="السوق *"
                    required
                    error={!!errors.market}
                    helperText={errors.market}
                  />
                )}
              />
            </FormControl>
          </Box>
          {/* صف الموقع والخريطة جنب بعض */}
          <Box display="flex" justifyContent="center" alignItems="flex-start" gap={2}>
            {/* حقل الموقع على اليمين */}
            <FormControl
              fullWidth
              error={!!iframeError || !!errors.location}
              sx={{ mb: 2, maxWidth: "50%" }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box flex={1}>
                  <Typography variant="body2">موقع المتجر على الخريطة *</Typography>
                  <TextField
                    label="كود التضمين (iframe) من خرائط جوجل *"
                    name="location"
                    value={formData.location || ""}
                    onChange={(e) => setFormData((prev) => ({ ...prev, location: e.target.value }))}
                    onBlur={handleIframeBlur}
                    error={!!iframeError || !!errors.location}
                    helperText={
                      errors.location ? (
                        <span>
                          يرجى إدخال موقع الخريطة. <br />
                          للحصول على كود التضمين:
                          <ul style={{ margin: 0, paddingRight: 18 }}>
                            <li>
                              اذهب إلى{" "}
                              <a
                                href="https://maps.google.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#1976d2",
                                  fontWeight: "bold",
                                  textDecoration: "underline",
                                }}
                              >
                                خرائط جوجل
                              </a>
                            </li>
                            <li>ابحث عن موقع متجرك</li>
                            <li>
                              اضغط على زر <b>مشاركة</b>
                            </li>
                            <li>
                              اختر <b>تضمين خريطة</b>
                            </li>
                            <li>
                              انسخ كود <b>HTML</b> بالكامل والصقه هنا
                            </li>
                          </ul>
                        </span>
                      ) : (
                        iframeError || (
                          <span>
                            اذهب إلى
                            <a
                              href="https://maps.google.com"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#1976d2",
                                fontWeight: "bold",
                                textDecoration: "underline",
                                margin: "0 4px",
                              }}
                            >
                              googlmaps
                            </a>
                            {" > "} ابحث عن موقعك {" > "} مشاركة {" > "} تضمين خريطة {" > "} نسخ
                            محتوى <b>HTML</b> {" > "} الصق هنا في حقل الموقع.
                          </span>
                        )
                      )
                    }
                    required
                    multiline
                    minRows={3}
                  />
                </Box>
                {/* زر الانتقال إلى الموقع */}
                {/* {iframeSrc && formData.lat && formData.lng && (
                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{ height: 40, whiteSpace: "nowrap", fontWeight: "bold" }}
                    onClick={() => {
                      const url = `https://www.google.com/maps?q=${formData.lat},${formData.lng}`;
                      window.open(url, "_blank", "noopener,noreferrer");
                    }}
                  >
                    الانتقال إلى الموقع
                  </Button>
                )} */}
              </Box>
            </FormControl>
            {/* الخريطة على اليسار */}
            {iframeSrc && !iframeError && (
              <Box width="100%" maxWidth={"50%"} minWidth={250} ml={2}>
                <iframe
                  title="خريطة المتجر"
                  src={iframeSrc}
                  width="100%"
                  height="260"
                  style={{ border: 0, borderRadius: 8 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                {/* عرض الإحداثيات إذا كانت متوفرة */}
                {/* {formData.lat && formData.lng && (
                  <Box mt={1} textAlign="center">
                    <span style={{ color: "#333", fontWeight: "bold", fontSize: 15 }}>
                      إحداثيات الموقع:
                    </span>
                    <span style={{ marginRight: 8, color: "#1976d2", fontFamily: "monospace" }}>
                      lat: {formData.lat}
                    </span>
                    <span style={{ color: "#1976d2", fontFamily: "monospace" }}>
                      lng: {formData.lng}
                    </span>
                  </Box>
                )} */}
              </Box>
            )}
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
            <FormControl fullWidth error={!!errors.street} sx={{ mb: 2 }}>
              <TextField
                label="الشارع *"
                name="street"
                value={formData.street}
                onChange={handleChange}
                error={!!errors.street}
                helperText={errors.street}
              />
            </FormControl>
            <FormControl fullWidth error={!!errors.zip_code} sx={{ mb: 2 }}>
              <TextField
                label="Zip Code*"
                name="zip_code"
                value={formData.zip_code}
                onChange={handleChange}
                error={!!errors.zip_code}
                helperText={errors.zip_code}
              />
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="SubCode*"
                name="subcode"
                value={formData.subcode}
                onChange={handleChange}
              />
            </FormControl>
          </Box>
        </Box>

        {/* Store Logo Upload */}
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            شعار المتجر
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleLogoChange}
            sx={{ display: "none" }}
            id="logo-upload"
            name="logo"
          />
          <label htmlFor="logo-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, borderColor: "secondary.focus", color: "primary.main" }}
            >
              شعار المتجر
            </Button>
          </label>
          {formData.logo && (
            <Avatar
              src={
                typeof formData.logo === "string"
                  ? formData.logo
                  : URL.createObjectURL(formData.logo)
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="textSecondary" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
          <FormHelperText error>{errors.logo}</FormHelperText>
        </Box>

        {/* زر صور المتجر */}
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            صور المتجر
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg", multiple: true }}
            onChange={handleStoreImagesChange}
            sx={{ display: "none" }}
            id="store-images-upload"
            name="store-images"
          />
          <label htmlFor="store-images-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}

              sx={{ width: 200, borderColor: "secondary.focus", color: "primary.main" }}
            >
              إضافة صور المتجر
            </Button>
          </label>
          <Box display="flex" gap={2} mt={2}>
            {storeImages.map((img, idx) => (
              <Avatar
                key={idx}
                src={URL.createObjectURL(img)}
                sx={{ width: 70, height: 70, border: "2px solid #ddd" }}
              />
            ))}
          </Box>
          <FormHelperText error>{imagesError}</FormHelperText>
        </Box>

        {/* Final Actions */}
        <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body2" color="textSecondary">
            * الحقول المطلوبة
          </Typography>
          <Box display="flex" gap={2}>
            <SubmitButton
              variant="primary"
              onClick={handleSubmit}
              sx={{ px: 4, color: "white !important" }}
            >
              حفظ
            </SubmitButton>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AddStoreForm;
